import { loadJS } from 'hobbit-base/modules/utils';
import useAppier from './appier'; // Appier SDK

export function extendStatisticsInit($hobbit, router, themeInstalled) {
  // 初始化GA
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  if (window.top === window && ($hobbit.$ctx.isProd() || $hobbit.$ctx.isPre())) {
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    window.gtag('js', new Date());
    Promise.all([
      $hobbit.$ctx.onload,
      themeInstalled,
    ]).then(() => {
      // #region GA/GTM 统计实例初始化
      const googleAnalyticsId = $hobbit.$theme?.gtmId ?? $hobbit.$theme?.gtagId;
      if (googleAnalyticsId) {
        window.gtag('config', googleAnalyticsId, { send_page_view: false });
        router.afterEach(to => { window.gtag('config', googleAnalyticsId, { page_path: to.path }); });
        const googleAnalyticsJS = $hobbit.$theme.gtmId ? 'gtm.js' : 'gtag/js';
        loadJS(`https://www.googletagmanager.com/${googleAnalyticsJS}?id=${googleAnalyticsId}`, 1e4).catch(error => {
          console.warn('load GA failed', error);
        });

        // 注册GA埋点适配器到框架统计通道
        $hobbit.$log.logersLoaded.push(() => Promise.resolve({
          login(userId) {
            window.gtag('set', { user_id: userId });
          },
          track(type, params) {
            if (/^page_/i.test(type)) {
              window.gtag('event', type, params);
            }
          },
        }));
      }
      // #endregion

      // #region singular 统计实例初始化
      if ($hobbit.$theme?.singular?.productId) {
        loadJS('https://web-sdk-cdn.singular.net/singular-sdk/latest/singular-sdk.js', 1e4, false).then(() => {
          router.afterEach(() => { window.singularSdk.pageVisit(); });
          const { sdkKey, sdkSecret, productId } = $hobbit.$theme.singular || {};
          const sconfig = new window.SingularConfig(sdkKey, sdkSecret, productId);
          window.singularSdk.init(sconfig);

          // 注册singular埋点适配器到框架统计通道
          $hobbit.$log.logersLoaded.push(() => Promise.resolve({
            login(userId) {
              window.singularSdk.login(userId);
            },
            track(type, params) {
              if (/^page_/i.test(type)) {
                window.singularSdk.event(type, params);
              }
            },
          }));
        }).catch(error => {
          console.warn('load singular failed', error);
        });
      }
      // #endregion

      // #region 百度统计
      if ($hobbit.$theme?.baiduId) {
        window._hmt = window._hmt || [];
        loadJS(`https://hm.baidu.com/hm.js?${$hobbit.$theme.baiduId}`, 1e4, false)
          .then(() => {
            router.afterEach(to => {
              window._hmt.push(['_trackPageview', to.path]);
            })
          })
          .catch(error => {
            console.warn('load baidu statisic failed', error);
          });
      }
      // #endregion

      // #region clarity
      if ($hobbit.$theme?.clarity?.clarityId) {
        (function(c, _, a){
          c[a] = c[a] || function() {(c[a].q = c[a].q || []).push(arguments)};
        })(window, document, $hobbit.$theme?.clarity?.clarityName || "clarity");
        loadJS(`https://www.clarity.ms/tag/${$hobbit.$theme?.clarity?.clarityId}`, 1e4, false)
          .catch(error => {
            console.warn('load clarity failed', error);
          });
      }
      // #endregion
    });
  }

  // 初始化第三方统计库
  Promise.all([$hobbit.$ctx.onload, themeInstalled]).then(() => {
    useAppier();
  });
  Promise.all([$hobbit.$ctx.onready, themeInstalled]).then(() => {
    if ($hobbit.$theme.vwoUrl) {
      loadJS($hobbit.$theme.vwoUrl, 1e4).catch(error => {
        console.warn('Load VWO Failed', error);
      });
    }
  });
}
